import OutletList from '@/pages/outlet/outlet-list/routes'
import OutletAccess from '@/pages/outlet/outlet-access/routes'
import OnlineStore from '@/pages/outlet/online-store/routes'

export default {
  path: 'outlet',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [...OutletList, ...OutletAccess, ...OnlineStore]
}
